import type { TimelineDesignTokens } from '@primeuix/themes/types/timeline'

export default {
  event: {
    minHeight: '5rem',
  },
  vertical: {
    eventContent: {
      padding: '0 1rem',
    },
  },
  horizontal: {
    eventContent: {
      padding: '1rem 0',
    },
  },
  eventMarker: {
    size: '1.115rem',
    content: {
      size: '0.57rem',
      background: '{primary.color}',
      insetShadow: 'none',
      borderRadius: '50%',
    },
    background: '{content.background}',
    borderColor: '{surface.400}',
    borderWidth: '2px',
    borderRadius: '50%',
  },
  eventConnector: {
    size: '1px',
    color: '{surface.400}',
  },
} satisfies TimelineDesignTokens
